export const PRACTICE_TEST = [
    {
        id: 1,
        test_name: 'Assessment Test',
        topic_ids: [9],
        use_practice_test_id: true,
        practice_test_id: 5,
        requires_subscription: false
    },
    {
        id: 2,
        test_name: 'Practice Test 1',
        use_practice_test_id: true,
        practice_test_id: 1,
        requires_subscription: true
    },
    {
        id: 3,
        test_name: 'Practice Test 2',
        use_practice_test_id: true,
        practice_test_id: 2,
        requires_subscription: true
    },
    {
        id: 4,
        test_name: 'Practice Test 3',
        use_practice_test_id: true,
        practice_test_id: 3,
        requires_subscription: true
    },
    {
        id: 5,
        test_name: 'Practice Test 4',
        use_practice_test_id: true,
        practice_test_id: 4,
        requires_subscription: true
    },
    {
        id: 6,
        test_name: 'Practice Test 5',
        use_practice_test_id: true,
        practice_test_id: 6,
        requires_subscription: true
    },
    {
        id: 7,
        test_name: 'Practice Test 6',
        use_practice_test_id: true,
        practice_test_id: 7,
        requires_subscription: true
    },
    {
        id: 8,
        test_name: 'Practice Test 7',
        use_practice_test_id: true,
        practice_test_id: 8,
        requires_subscription: true
    },
    {
        id: 9,
        test_name: 'Practice Test 8',
        use_practice_test_id: true,
        practice_test_id: 9,
        requires_subscription: true
    },
];

export const APP_DOMAIN_LIST = [
    {
        id: 1,
        domain_name: 'Security and Risk Management',
        chapters: [1, 2, 3, 4],
        show_proficiency: true,
        icon: 'sitemap',
        requires_subscription: true,
        num_questions: 10,
        num_flashcards: 10,
        num_articles: 3,
    },
    {
        id: 2,
        domain_name: 'Asset Security',
        chapters: [5],
        show_proficiency: true,
        icon: 'safe',
        requires_subscription: true,
        num_questions: 10,
        num_flashcards: 10,
        num_articles: 3,
    },
    {
        id: 3,
        domain_name: 'Security Architecture and Engineering',
        chapters: [6, 7, 8, 9, 10],
        show_proficiency: true,
        icon: 'cogs',
        requires_subscription: true,
        num_questions: 10,
        num_flashcards: 10,
        num_articles: 3,
    },
    {
        id: 4,
        domain_name: 'Communication and Network Security',
        chapters: [11, 12],
        show_proficiency: true,
        icon: 'account-network',
        requires_subscription: true,
        num_questions: 10,
        num_flashcards: 10,
        num_articles: 3,
    },
    {
        id: 5,
        domain_name: 'Identity and Access Management (IAM)',
        chapters: [13, 14],
        show_proficiency: true,
        icon: 'fingerprint',
        requires_subscription: true,
        num_questions: 10,
        num_flashcards: 10,
        num_articles: 3,
    },
    {
        id: 6,
        domain_name: 'Security Assessment and Testing',
        chapters: [15],
        show_proficiency: true,
        icon: 'lock-open-check',
        requires_subscription: true,
        num_questions: 10,
        num_flashcards: 10,
        num_articles: 3,
    },
    {
        id: 7,
        domain_name: 'Security Operations',
        chapters: [16, 17, 18, 19],
        show_proficiency: true,
        icon: 'shield-account',
        requires_subscription: true,
        num_questions: 25,
        num_flashcards: 10,
        num_articles: 3,
    },
    {
        id: 8,
        domain_name: 'Software Development Security',
        chapters: [20, 21],
        show_proficiency: true,
        icon: 'monitor-lock',
        requires_subscription: true,
        num_questions: 10,
        num_flashcards: 10,
        num_articles: 3,
    },
];

export const QUESTION_VERSION_OF_JSON = 1
